export default {
    trialStudy: '申请免费试读',
    trialStudy_button: '提交申请',
    trialStudy_tip: '请检查邮箱格式',

    login: '登录',
    login_forget: '忘记密码?',
    login_button: '登录',

    register: '注册',
    register_verify: '获取验证码',
    register_forget: '忘记密码?',
    register_tip: '点击注册，则表示我已阅读并接受哈兔用户条款/隐私政策',

    found: '找回密码',
    found_verify: '获取验证码',
    found_tip: '密码长度必须在6-20个字符之间，只允许字母、数字以及部分特殊符号',
    found_password: '密码登录',
    found_register: '立即注册',
};